import { Filtering, Selecting } from '@qualio/ui-components';
import { useMemo } from 'react';
import { DocumentStatus } from '../../../../api/model/document';
import { defaultStatusFilterOption } from './constants';

export const SelectionWrapper = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  const filtering = Filtering.useFilteringMaybe();

  const deletedDraftStatusSelected = useMemo(() => {
    const statusFilters =
      filtering?.filters.status?.value ?? defaultStatusFilterOption;
    return statusFilters === DocumentStatus.Deleted;
  }, [filtering?.filters.status?.value]);

  if (deletedDraftStatusSelected) {
    return <>{children}</>;
  }

  return (
    <Selecting.DefaultSelectionProvider
      onChange={() => {
        return;
      }}
    >
      {children}
    </Selecting.DefaultSelectionProvider>
  );
};
